<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="题库分类">
        <Input
          v-model="name"
          style="width:200px"
          placeholder="请输入分类名称关键字"
          clearable
          @keydown.native.prevent.enter="getList"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="getList">搜索</Button>
          <Button icon="md-undo" @click="name = '';getList(true)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button @click="addClassify()" type="primary">新增分类</Button>
    <Modal v-model="addClassifyModal" :title="modalText" ref="modal">
      <div class="course-type">
        <Form ref="classifyForm" :rules="ruleValidate" :model="addClassifyInfo" :label-width="80">
          <FormItem label="所属分类">
            <p>{{addClassifyInfo.parent_name||"无"}}</p>
          </FormItem>
          <FormItem label="分类名称" prop="name">
            <Input style="width:300px" type="text" v-model="addClassifyInfo.name" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="addClassifyModal = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
    <div class="content">
      <TreeGrid
        :rows="list"
        :columns="columns"
        :maxLevel="2"
        :formatter="formatter"
        childrenProperty="child"
      >
        <template slot-scope="{ row }" slot="action">
          <Button @click="addClassify(row)" type="text" size="small" :style="{visibility:!row.parent_id?'visible':'hidden'}">新增-</Button>
          <Button @click="editClassify(row)" type="text" size="small">编辑-</Button>
          <Button @click="deleteClassify(row)" type="text" size="small">删除</Button>
        </template>
      </TreeGrid>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionBankCatagory",
  data() {
    return {
      addClassifyModal: false,
      modalText: "新增分类",
      expandId: "",
      ruleValidate: {
        name: [{ required: true, message: "分类名称必须填写", trigger: "blur" }]
      },
      columns: [
        {
          title: "分类名称",
          key: "name"
        },
        {
          title: "题库数量",
          key: "ques_bank_amount",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          width: 140
        }
      ],
      name: "",
      addClassifyInfo: {},
      list: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    addClassify(row) {
      this.addClassifyInfo = {};
      if (row) {
        this.addClassifyInfo.parent_id = row.id;
        this.addClassifyInfo.parent_name = row.name;
      } else {
        this.addClassifyInfo.parent_name = "无";
      }
      this.addClassifyInfo.name = "";
      this.modalText = "新增分类";
      this.addClassifyModal = true;
    },
    editClassify(row) {
      this.addClassifyInfo = {};
      this.modalText = "编辑分类";
      this.addClassifyInfo.id = row.id;
      this.addClassifyInfo.name = row.name;
      this.addClassifyInfo.parent_id = row.parent_id;
      this.addClassifyInfo.parent_name = row.parent_name;
      this.addClassifyModal = true;
    },
    async deleteClassify(row) {
      if (row.hasOwnProperty("child") && row.child.length > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "当前分类下含有子分类，无法删除"
        });
        return;
      }
      if (row.ques_bank_amount > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "当前分类已被使用，无法删除"
        });
        return;
      }
      await this.$promiseConfirm("确定要删除该分类吗？");
      await this.$http.delete("/api/ques/classify/" + row.id);
      this.expandId = row.parent_id;
      this.$Message.deleteSuccess();
      this.getList();
    },
    async save() {
      this.$refs.classifyForm.validate(async valid => {
        if (!valid) {
          return;
        }
        if (this.modalText == "新增分类") {
          let data = { name: this.addClassifyInfo.name };
          if (this.addClassifyInfo.parent_id) {
            data.parent_id = this.addClassifyInfo.parent_id;
          }
          await this.$http.post("/api/ques/classify", data);
          this.expandId = this.addClassifyInfo.parent_id;
          this.getList(true);
        } else {
          await this.$http.put(
            "/api/ques/classify/" + this.addClassifyInfo.id,
            {
              name: this.addClassifyInfo.name
            }
          );
          this.expandId = this.addClassifyInfo.parent_id;
          this.getList();
        }
        this.addClassifyModal = false;
        this.$Message.saveSuccess();
      });
    },
    async getList(params) {
      if (params) {
        this.page = 1;
      }
      let data = await this.$http.get("/api/ques/classify", {
        name: this.name
      });
      data.forEach(item => {
        if (
          (item.id == this.expandId || this.name != "") &&
          item.child &&
          item.child.length > 0
        ) {
          item._expanded = true;
        }
      });
      this.list = data;
      this.list.forEach(i => {
        if (!i.child || i.child.length === 0) {
          i._disableExpand = true;
        }
      });
    },
    formatter(row) {
      if (!row.child) {
        return;
      }
      row.child.forEach(child => {
        child.parent_name = row.name;
      });
    }
  }
};
</script>